<template>
  <div>
    <el-form style="padding: 0 40px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="课程名称：">
            <el-input v-model="courseTitle" style="width: 200px" placeholder="请输入课程名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="课程分类：">
            <el-cascader v-model="categoryId" placeholder="请选择课文分类" :options="courseCategory" clearable
              :props="{ expandTrigger: 'hover', emitPath: false, checkStrictly: true }">
            </el-cascader>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="操作时间：">
            <el-date-picker v-model="qTime" type="datetimerange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" format="yyyy-MM-DD HH:mm:ss" value-format="yyyy-MM-DD HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item v-if="this.activeName == 'courseB'" label="审核状态：">
            <el-select v-model="examineStatus" placeholder="请选择审核状态">
              <el-option label="待审核" :value="0"></el-option>
              <el-option label="审核中" :value="1"></el-option>
              <el-option label="已审核" :value="2"></el-option>
              <el-option label="审核失败" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-else> </el-form-item>
        </el-col>
        <el-col :span="18">
          <div class="flex jc-fe">
            <el-button type="primary" @click="search()"> <i class="el-icon-search" style="margin-right: 5px"></i>查询
            </el-button>
            <el-button @click="search('refresh')"> <i class="el-icon-refresh" style="margin-right: 5px"></i>重置
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-tabs v-model="activeName" type="card" @tab-click="search('refresh')">
      <el-tab-pane label="课程发布" name="courseA">
        <courseA ref="courseA" :columns="columns" :labelList="labelList"></courseA>
      </el-tab-pane>
      <el-tab-pane label="课程审核" name="courseB">
        <courseB ref="courseB" :columns="columns" :labelList="labelList"></courseB>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import courseA from './courseA';
import courseB from './courseB';

export default {
  components: {
    courseA,
    courseB,
  },
  props: {
    labelList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      courseCategory: [],
      activeName: 'courseA',

      columns: [],

      searchForm: {},

      courseTitle: null,
      categoryId: null,
      qTime: [],

      examineStatus: null,
    };
  },
  created() {
    this.columns = [
      {
        type: 'index',
        title: '序号',
      },

      {
        key: 'id',
        title: '课程ID',
      },
      {
        key: 'courseTitle',
        title: '课程名称',
        width: 200,
        render: ({ row }) => {
          return (
            <div>
              <div>{row.courseTitle}</div>
              <div class="flex">

                <el-tooltip class="mr-5" effect="dark" content={`观看人数：${row.watchNum || 0}`} placement="top-start">
                  <div>
                    <i class="el-icon-view mr-5"></i>
                    {row.watchNum || 0}
                  </div>
                </el-tooltip>
                <el-tooltip class="mr-5" effect="dark" content={`评论人数：${row.remarkNum || 0}`} placement="top-start">
                  <div>
                    <i class="el-icon-chat-line-round mr-5"></i>
                    {row.remarkNum || 0}
                  </div>
                </el-tooltip>
                {/* <i class="el-icon-view"></i>
                <div>
                  {row.praiseNum || 0}
                </div> */}
                <el-tooltip class="mr-5" effect="dark" content={`收藏人数：${row.collectNum || 0}`} placement="top-start">
                  <div>
                    <i class="el-icon-star-off mr-5"></i>
                    {row.collectNum || 0}
                  </div>
                </el-tooltip>
                <el-tooltip class="mr-5" effect="dark" content={`分享人数：${row.shareNum || 0}`} placement="top-start">
                  <div>
                    <i class="el-icon-share mr-5"></i>
                    {row.shareNum || 0}
                  </div>
                </el-tooltip>
              </div>
            </div >
          );
        },
      },
      {
        key: 'categoryName',
        title: '课程分类',
      },
      {
        key: 'updateDate',
        title: '操作时间',
      },
      {
        key: 'bgUserName',
        title: '操作人',
      },
    ];
  },
  mounted() {
    this.getCourseCategory();

  },
  methods: {
    async getCourseCategory() {
      this.courseCategory = await this.$store.dispatch('category/getCourseCategory');
    },
    search(msg) {
      this.searchForm = {
        courseTitle: this.courseTitle,
        categoryId: this.categoryId,
        startTime: this.qTime[0],
        endTime: this.qTime[1],
      };

      if (msg == 'refresh') {
        this.courseTitle = null;
        this.categoryId = null;
        this.examineStatus = null;
        this.qTime = [];
        this.searchForm = {};
      }

      if (this.activeName == 'courseB') {
        this.searchForm.examineStatus = this.examineStatus;
      }
      this.$refs[this.activeName].getList(this.searchForm);
    },
  },
};
</script>
<style scoped></style>
